import { render, staticRenderFns } from "./marmic-services-detail-table-panel.vue?vue&type=template&id=196e470e&scoped=true&lang=pug"
import script from "./marmic-services-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./marmic-services-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./marmic-services-detail-table-panel.vue?vue&type=style&index=0&id=196e470e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e470e",
  null
  
)

export default component.exports